import { WfApproveRequest } from "./request/WfApproveRequest";

export class Overtime {
    name: string;
    surname: string;
    departmentName: string;
    departmentId: number;
    branchCode: string;
    description: string;
    employeeId: number;
    endTime: string;
    fileList: FileList[];
    filePath: string;
    id: number;
    isRestDay: number;
    overtimeDate: string;
    overtimeTypeId: number;
    projectCode: string;
    proxyManagerId: number;
    readAndAprroved: number;
    startTime: string;
    tenantCode: string;
    isNew?: boolean;
    tabNo?: number;
    isCompleted: boolean;
    branchName: string;
    projectName: string;
    overtimeHours: number;
    tenantName: string;
    overtimeTypeName: string;
}
export class FileList {
    alreadyStored: boolean;
    fileBase64: string;
    fileName: string;
    recordId: number;
    willBeDeleted: boolean;
}

export class OvertimeRejectRequest extends WfApproveRequest {
    rejectReasonId?: number;
    rejectDescription?: string;
}

